import type { TasEligibility } from './tas-eligibility.type.ts';
export interface TasEligibilityExtension extends TasEligibility {}
export class TasEligibilityExtension {
  get isActive() {
    return this.state === 'TAS.EligibilityState.ACTIVE';
  }
}

const Registration = {
  kind: 'object',
  name: 'tas-eligibility',
  features: TasEligibilityExtension,
};
export default Registration;
